import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LevelService } from '../../providers/level/level.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-level-modal',
  templateUrl: './level-modal.component.html',
  styleUrls: ['./level-modal.component.scss']
})
export class LevelModalComponent implements OnInit {

  levelForm: FormGroup;
  router: any;
  local_data: any;
  id: number;
  description: string;
  heirarchy: string;
  
  constructor(public fb: FormBuilder,
    public dialogRef: MatDialogRef<LevelModalComponent>,
    private levelService: LevelService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }

  }

  createForm() {
    this.levelForm = new FormGroup({
      description: new FormControl(),
      heirarchy: new FormControl()
    });
    this.levelForm = this.fb.group({
      description: ['', [Validators.required]],
      heirarchy: ['', [Validators.required]]
    })
  }

  editForm() {
    this.levelForm = new FormGroup({
      description: new FormControl(),
      heirarchy: new FormControl()
    });
    this.levelForm = this.fb.group({
      description: [this.data.description, [Validators.required]],
      heirarchy: [this.data.heirarchy, [Validators.required]]
    })
  }


  addLevel() {
    if (!this.id) {
      console.log(this.levelForm.value);
      this.levelService.addLevel(this.levelForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );

    } else {

      console.log(this.levelForm.value);
      this.levelService.editLevel(this.id, this.levelForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
